import React from 'react'
import Button from '../Button/Button'
import FactorList from '../FactorList/FactorList'
import factor from './Factor.module.css'
const Factor = (props) => {
    
    return (
        <div className={factor.factorHolder}>
            <h1 className={factor.title}>فاکتور</h1>
            <ul className={factor.factorList}>
                {props.data.map((item,index)=>{
                    return(
                        <>
                            <h3 className={factor.superyName}>{item.name} </h3>
                            {item.products.map(val=>{
                                return <FactorList key={index} data={val}/>
                            })}
                        </>
                    )
                })}
            </ul>
            <div className={factor.btnHolder}>
                <Button ClassBtn={"confrimBtn"} Value={"بستن"} ClickHandler={props.close}/>
            </div>
        </div>
    )
}

export default Factor
